import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
import { UPDATE_WIDGET_BTN_TEXT } from "views/components/widgets/SaveOrCancelButtons";
import { UPDATE_WIDGET_PREVIEW_BTN_TEXT } from "views/components/aggregationwizard/ElementsConfigurationActions";
import { useIsInteractiveMode } from "../contexts/InteractiveContext";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: inherit;
`;
const SpacedHeading = styled.h2(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.sm};
  `
);
const EmptyAggregationContent = ({ toggleEdit, editing = false }) => {
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);
  const interactive = useIsInteractiveMode();
  const text = editing ? /* @__PURE__ */ React.createElement("p", null, "You are now editing the widget.", /* @__PURE__ */ React.createElement("br", null), "To see results, add at least one metric. You can group data by adding rows/columns.", /* @__PURE__ */ React.createElement("br", null), 'You can preview widget search results by clicking on "', UPDATE_WIDGET_PREVIEW_BTN_TEXT, '".', /* @__PURE__ */ React.createElement("br", null), 'To finish, click "', UPDATE_WIDGET_BTN_TEXT, '" to save, "Cancel" to abandon changes.') : /* @__PURE__ */ React.createElement("p", null, "Please", " ", interactive ? /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: toggleEdit }, "Edit") : "edit", " ", "the widget to see results here.");
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SpacedHeading, null, "Empty Aggregation"), text));
};
export default EmptyAggregationContent;
